import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from "../../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, {
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import {
  convertToLowestUnit,
  ExportAvailableInCSVForReports,
  exportFromula,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const SupplierMonthlyReport = (props) => {
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [grandTotal, setGrandTotal] = useState(0);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const ordersRequestId = useRef(0);

  const [supplierFilter, setSupplierFilter] = useState([]);
  const [branchFilter, setBranchFilter] = useState([]);
  const [itemFilter, setItemFilter] = useState([]);
  const [invoiceFilter, setInvoiceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [activeMenu, setActiveMenu] = useState(null);

  const [previousFilteredOrders, setPreviousFilteredOrders] = useState([]);

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(moment(currentDay).format("YYYY-MM-DD"));
    setDateTo(moment(currentDay).format("YYYY-MM-DD"));
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchText, setSearchText] = useState("");

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      let url =
        process.env.REACT_APP_BASEURL + "reports/supplier_monthly_report";
      const response = await postSubmitForm(url, {
        supplier_id: "All",
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
      });
      if (requestId !== ordersRequestId.current) return false;

      let allData = [];
      if (response && response.status === 1) {
        allData = response.data || [];
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }

      if (allData.length <= 0) {
        showNotification("No Orders data found", "error");
      }
      const processedData = (allData || []).map((row, index) => {
        const invoiceSet = new Set();
        let isReceived = false;
        let receivingDate = "";

        const deliveryDetails = row.delivery_details || [];
        deliveryDetails.forEach((item) => {
          if (
            item.item_id === row.items.item_id &&
            item.invoice_number &&
            item.invoice_number !== "undefined"
          ) {
            invoiceSet.add(item.invoice_number);
          }
        });

        deliveryDetails.forEach((item) => {
          if (item.item_id === row.items.item_id) {
            if (item.receive && item.receive.length > 0) {
              isReceived = true;
              if (
                !receivingDate ||
                (item.receiving_date &&
                  moment(item.receiving_date).isAfter(receivingDate))
              ) {
                receivingDate = item.receiving_date;
              }
            }
          }
        });

        const invoices = Array.from(invoiceSet).join("\n");

        return {
          ...row,
          row_key: row.id || `row_${index}`,
          supplier_name:
            row.supplier && row.supplier.name ? row.supplier.name : "",
          branch_name:
            row.branch_details && row.branch_details.name
              ? row.branch_details.name
              : "",
          item_name: row.items && row.items.name ? row.items.name : "",
          formatted_invoice_number: invoices,
          is_received: isReceived,
          receiving_date: receivingDate,
        };
      });
      setAllOrders(processedData);
      setFilteredOrders(processedData);
      setSupplierFilter([]);
      setBranchFilter([]);
      setItemFilter([]);
      setInvoiceFilter("");
      setStatusFilter([]);
      setSearchText("");
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  useEffect(() => {
    if (allOrders.length > 0) {
      const filtered = applyFilters(allOrders);
      setFilteredOrders(filtered);

      const total = filtered
        .filter((item) => item.is_received)
        .reduce((sum, order) => {
          return sum + (Number(order.items.total_price) || 0);
        }, 0);
      setGrandTotal(Number(total.toFixed(2)));
    }
  }, [
    allOrders,
    supplierFilter,
    branchFilter,
    itemFilter,
    invoiceFilter,
    searchText,
    statusFilter,
  ]);

  const handleSearch = (searchValue) => {
    setSearchText(searchValue || "");
    // if (searchValue) {
    //   setSupplierFilter([]);
    //   setBranchFilter([]);
    //   setItemFilter([]);
    //   setStatusFilter([]);
    //   setInvoiceFilter("");
    // }
  };

  const CustomMultiSelect = ({
    title,
    options,
    selectedValues,
    onSelectionChange,
    formSelect,
    onMenuToggle,
    children,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);
    const containerRef = useRef(null);
    const [dropdownWidth, setDropdownWidth] = useState(0);

    useEffect(() => {
      if (dropdownRef.current) {
        setDropdownWidth(dropdownRef.current.offsetWidth);
      }
    }, []);

    useEffect(() => {
      if (formSelect) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }, [formSelect]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          containerRef.current &&
          !containerRef.current.contains(event.target)
        ) {
          setIsOpen(false);
          onMenuToggle(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      };
    }, [isOpen, onMenuToggle]);

    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    const handleCheckboxChange = (value, e) => {
      e.preventDefault();
      e.stopPropagation();
      let newSelected;
      if (selectedValues.includes(value)) {
        newSelected = selectedValues.filter((v) => v !== value);
      } else {
        newSelected = [...selectedValues, value];
      }
      onSelectionChange(newSelected);
      setIsOpen(true);
    };

    const clearAll = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onSelectionChange([]);
    };

    const selectAll = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onSelectionChange(options);
    };

    const toggleDropdown = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newIsOpen = !isOpen;
      setIsOpen(newIsOpen);
      onMenuToggle(newIsOpen);
    };

    return (
      <div
        className="custom-multi-select"
        style={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          overflow: "visible",
        }}
        ref={(el) => {
          dropdownRef.current = el;
          containerRef.current = el;
        }}
      >
        <div
          onClick={toggleDropdown}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 8px",
            cursor: "pointer",
            fontSize: "11px",
            color: "#495057",
            border: "1px solid #ced4da",
            borderRadius: "4px",
            backgroundColor: selectedValues.length > 0 ? "#e9ecef" : "#fff",
            transition: "all 0.2s",
            minWidth: "120px",
          }}
        >
          <i
            className="mdi mdi-filter-variant"
            style={{ fontSize: "14px" }}
          ></i>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
            }}
          >
            {selectedValues.length === 0
              ? title
              : selectedValues.length === 1
                ? selectedValues[0]
                : `${selectedValues.length} selected`}
          </span>
          {selectedValues.length > 0 && (
            <i
              className="mdi mdi-close"
              style={{
                fontSize: "14px",
                padding: "2px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                clearAll(e);
              }}
            ></i>
          )}
        </div>

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: `${Math.max(dropdownWidth, 200)}px`,
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              zIndex: 9999,
              marginTop: "4px",
              border: "1px solid #ced4da",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
          >
            {children}
            <div
              style={{
                padding: "8px",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  fontSize: "11px",
                  padding: "4px 8px",
                  width: "100%",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  outline: "none",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "4px",
                padding: "8px",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              <button
                onClick={selectAll}
                onMouseDown={(e) => e.preventDefault()}
                style={{
                  fontSize: "10px",
                  padding: "2px 8px",
                  flex: 1,
                  border: "1px solid #007bff",
                  backgroundColor: "transparent",
                  color: "#007bff",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Select All
              </button>
              <button
                onClick={clearAll}
                onMouseDown={(e) => e.preventDefault()}
                style={{
                  fontSize: "10px",
                  padding: "2px 8px",
                  flex: 1,
                  border: "1px solid #6c757d",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Clear All
              </button>
            </div>

            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                padding: "4px",
              }}
            >
              {filteredOptions.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "8px",
                    color: "#6c757d",
                    fontSize: "11px",
                  }}
                >
                  No options found
                </div>
              ) : (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "4px 8px",
                      cursor: "pointer",
                      fontSize: "11px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      borderRadius: "4px",
                      transition: "background-color 0.2s",
                      backgroundColor: selectedValues.includes(option)
                        ? "#e9ecef"
                        : "transparent",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCheckboxChange(option, e);
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                    }}
                    onMouseEnter={(e) => {
                      if (!selectedValues.includes(option)) {
                        e.target.style.backgroundColor = "#f8f9fa";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!selectedValues.includes(option)) {
                        e.target.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <div
                      style={{
                        width: "14px",
                        height: "14px",
                        border: "1px solid #ced4da",
                        borderRadius: "3px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: selectedValues.includes(option)
                          ? "#007bff"
                          : "transparent",
                        transition: "all 0.2s",
                      }}
                    >
                      {selectedValues.includes(option) && (
                        <i
                          className="mdi mdi-check"
                          style={{ color: "#fff", fontSize: "10px" }}
                        ></i>
                      )}
                    </div>
                    <span
                      style={{
                        color: "#495057",
                        flex: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleCheckboxChange(option, e);
                      }}
                    >
                      {option}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const [sizePerPage, setSizePerPage] = useState(100);
  const customTotal = (from, to, size) => (
    <div
      className="react-bootstrap-table-pagination-total"
      style={{
        marginTop: "100px",
        textAlign: "left",
      }}
    >
      Showing {from} to {to} of {size} Results
    </div>
  );
  const paginationOptions = {
    onSizePerPageChange: (nextSizePerPage) => {
      setSizePerPage(nextSizePerPage);
    },
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      { text: "All", value: filteredOrders.length || 100 },
    ],

    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    ignoreSinglePage: true,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPage: sizePerPage,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    alwaysShowAllBtns: false,
    withFirstAndLast: false,
  };

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      dataField: "supplier_name",
      text: props.t("Supplier Name"),
      sort: true,
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span>{column.text}</span>
            {sortElement}
          </div>
          <CustomMultiSelect
            title="Filter Suppliers"
            options={[
              ...new Set(
                allOrders.map((row) => row.supplier_name).filter(Boolean),
              ),
            ].sort()}
            selectedValues={supplierFilter}
            onSelectionChange={(newValues) => {
              setSupplierFilter(newValues);
              setActiveMenu("supplier");
            }}
            formSelect={activeMenu === "supplier"}
            onMenuToggle={(isOpen) => {
              setActiveMenu(isOpen ? "supplier" : null);
            }}
          >
            {filterElement}
          </CustomMultiSelect>
        </div>
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("PO Details"),
      dataField: "status",
      sort: true,
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span>{column.text}</span>
            {sortElement}
          </div>
          <CustomMultiSelect
            title="Filter Status"
            options={[
              ...new Set(allOrders.map((row) => row.status).filter(Boolean)),
            ].sort()}
            selectedValues={statusFilter}
            onSelectionChange={(newValues) => {
              setStatusFilter(newValues);
              setActiveMenu("status");
            }}
            formSelect={activeMenu === "status"}
            onMenuToggle={(isOpen) => {
              setActiveMenu(isOpen ? "status" : null);
            }}
          >
            {filterElement}
          </CustomMultiSelect>
        </div>
      ),
      formatter: (cell, row) => (
        <div>
          <div
            style={{
              fontWeight: "500",
              color: "blue",
              textDecoration: "underline",
            }}
          >
            <a
              href={"/purchase_order?po_id=" + row.po_id}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {row.po_id}
            </a>
          </div>
          <small
            className={`badge badge-${row.status === "Closed" ? "success" : row.status === "Pending" ? "danger" : "warning"}`}
          >
            {row.status}
          </small>
          &nbsp;
          <small
            hidden={!row.is_returned}
            className={`badge badge`}
            style={{
              backgroundColor: "purple",
              color: "white",
              marginLeft: "5px",
            }}
          >
            Returned
          </small>
          <div style={{ fontSize: "11px", color: "#6c757d" }}>
            {moment(row.createdAt).format("DD/MM/YYYY")}
          </div>
        </div>
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_name",
      sort: true,
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span>{column.text}</span>
            {sortElement}
          </div>
          <CustomMultiSelect
            title="Filter Branches"
            options={[
              ...new Set(
                allOrders.map((row) => row.branch_name).filter(Boolean),
              ),
            ].sort()}
            selectedValues={branchFilter}
            onSelectionChange={(newValues) => {
              setBranchFilter(newValues);
              setActiveMenu("branch");
            }}
            formSelect={activeMenu === "branch"}
            onMenuToggle={(isOpen) => {
              setActiveMenu(isOpen ? "branch" : null);
            }}
          >
            {filterElement}
          </CustomMultiSelect>
        </div>
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Receiving Date"),
      dataField: "receiving_date",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return row.receiving_date
          ? moment(row.receiving_date).format("DD/MM/YYYY")
          : "";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "item_name",
      text: props.t("Item"),
      sort: true,
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span>{column.text}</span>
            {sortElement}
          </div>
          <CustomMultiSelect
            title="Filter Items"
            options={[
              ...new Set(allOrders.map((row) => row.item_name).filter(Boolean)),
            ].sort()}
            selectedValues={itemFilter}
            onSelectionChange={(newValues) => {
              setItemFilter(newValues);
              setActiveMenu("item");
            }}
            formSelect={activeMenu === "item"}
            onMenuToggle={(isOpen) => {
              setActiveMenu(isOpen ? "item" : null);
            }}
          >
            {filterElement}
          </CustomMultiSelect>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <div
            title={`${row.items.unit_levels ? `Formula: ${exportFromula(row.items.unit_levels)}` : ""}`}
            className="items_name"
            style={{
              cursor: "pointer",
            }}
          >
            {row.item_name}
          </div>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Quantities"),
      dataField: "quantities_display",
      isDummyField: true,
      formatter: (cell, row) => {
        let TotalReceived = 0;
        let TotalFree = 0;
        let lastUnitObj = row.items?.unit_levels?.at(-1)?.unit;
        const deliveryDetails = row.delivery_details || [];

        deliveryDetails.forEach((detail) => {
          if (detail.item_id === row.items.item_id && !detail.free) {
            TotalReceived += convertToLowestUnit(
              row.items?.unit_levels,
              detail.receive,
            );
          }
          if (detail.item_id === row.items.item_id && detail.free) {
            TotalFree += convertToLowestUnit(
              row.items?.unit_levels,
              detail.receive,
            );
          }
        });

        const quantity = [{ unit: lastUnitObj, value: Number(TotalReceived) }];
        let convertedQuantity = GetUpdatedDelivered(
          quantity,
          row.items?.unit_levels,
        );

        const freeQuantity = [{ unit: lastUnitObj, value: Number(TotalFree) }];
        let convertedFreeQuantity = GetUpdatedDelivered(
          freeQuantity,
          row.items?.unit_levels,
        );

        return (
          <div className="quantities-column">
            <div style={{ marginBottom: "4px" }}>
              <strong>Ordered:</strong>{" "}
              {formatUnitsForReport(row.items.quantity)}
            </div>
            {convertedQuantity.every((o) => o.value === 0) ? (
              ""
            ) : (
              <div style={{ marginBottom: "4px" }}>
                <strong>Received:</strong>{" "}
                {formatUnitsForReport(convertedQuantity)}
              </div>
            )}
            {convertedFreeQuantity.every((o) => o.value === 0) ? (
              ""
            ) : (
              <div>
                <strong>Free:</strong>{" "}
                {formatUnitsForReport(convertedFreeQuantity)}
              </div>
            )}
            {row?.returned_quantity?.every((o) => o.value === 0) ? (
              " "
            ) : (
              <div hidden={!row.is_returned}>
                <strong>Returned:</strong>{" "}
                {formatUnitsForReport(row?.returned_quantity)}
              </div>
            )}
          </div>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      dataField: "formatted_invoice_number",
      text: props.t("Invoices"),
      sort: false,
      filter: textFilter({
        onFilter: (filterValue) => {
          // console.log(filterValue,"fv");

          if (!filterValue) {
            setFilteredOrders(previousFilteredOrders);
          } else {
            setInvoiceFilter(filterValue);
          }
        },
        placeholder: "Search Invoice...",
      }),
      formatter: (cell, row, rowIndex) => {
        return <div style={{ maxWidth: "100px" }}>{cell}</div>;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "items.price",
      text: props.t("Price Details"),
      formatter: (cell, row) => {
        return (
          <div
            className="price-details"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
              }}
            >
              <span style={{ color: "#495057" }}>PO Price:</span>
              <span style={{ fontWeight: "500" }}>
                {row.items.price
                  ? `QR ${Number(row.items.price.toFixed(2))}/${row.items.unit_for_po}`
                  : "-"}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
                borderTop: "1px dashed gray",
                paddingTop: "2px",
              }}
              hidden={!row.is_received}
            >
              <span style={{ color: "#495057" }}>Inv. Price:</span>
              <span
                style={{
                  fontWeight: "500",
                  color:
                    row.new_price > row.items.price
                      ? "#dc3545"
                      : row.new_price < row.items.price
                        ? "#28a745"
                        : "#495057",
                }}
              >
                {row.new_price
                  ? `QR ${Number(row.new_price.toFixed(2))}/${row.items.unit_for_po}`
                  : "-"}
              </span>
            </div>
          </div>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "items.total_price",
      text: props.t("Total"),
      sort: true,
      formatter: (cell, row) => {
        return row.is_received ? row.items.total_price : null;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Closed") {
      style.backgroundColor = "#b0ff9e";
    } else if (
      row.status === "Partially Delivered" ||
      row.status === "Approved" ||
      row.status === "Dispatched"
    ) {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Pending") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
    const fileName = "supplier_monthly_report";
    const exportType = "xls";

    let data_to_export = filteredOrders;
    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        let invoices = "";
        let receivingdDate = "";
        let TotalReceived = 0;
        let TotalFreeReceived = 0;
        let lastUnitObj = v.items?.unit_levels?.at(-1)?.unit;

        (v.delivery_details || []).forEach((detail) => {
          if (detail.item_id === v.items.item_id && !detail.free) {
            TotalReceived += convertToLowestUnit(
              v.items?.unit_levels,
              detail.receive,
            );
            receivingdDate = moment(detail.receiving_date).format(
              "DD/MM/YYYY HH:mm:ss",
            );
          }
          if (detail.item_id === v.items.item_id && detail.free) {
            TotalFreeReceived += convertToLowestUnit(
              v.items?.unit_levels,
              detail.receive,
            );
          }
        });

        const quantity = [{ unit: lastUnitObj, value: Number(TotalReceived) }];
        let convertedQuantity = GetUpdatedDelivered(
          quantity,
          v.items?.unit_levels,
        );
        const freeQuantity = [
          { unit: lastUnitObj, value: Number(TotalFreeReceived) },
        ];
        let convertedFreeQuantity = GetUpdatedDelivered(
          freeQuantity,
          v.items?.unit_levels,
        );

        const formattedInvoices = v.formatted_invoice_number
          ? v.formatted_invoice_number.split("\n").join(", ")
          : "";
        data.push({
          "Supplier Name": v.supplier_name,
          "PO ID": v.po_id,
          Branch: v.branch_name,
          Status: v.status,
          "Order Date": moment(v.createdAt).format("DD/MM/YYYY"),
          "Item Name": v.item_name,
          Formula: v.items.unit_levels && exportFromula(v.items.unit_levels),
          "Ordered Quantity": ExportAvailableInCSVForReports(v.items.quantity),
          "Received Quantity": ExportAvailableInCSVForReports(
            convertedQuantity.length > 0 ? convertedQuantity : [],
          ),
          "Free Items": ExportAvailableInCSVForReports(
            convertedFreeQuantity.length > 0 ? convertedFreeQuantity : [],
          ),
          Return: v.is_returned ? "Yes" : "No",
          "Returned Quantity": ExportAvailableInCSVForReports(
            v.returned_quantity,
          ),
          Invoices: formattedInvoices,
          "Purchasing Unit": v.items.unit_for_po,
          "PO Price": v.items.price,
          "Invoice Price":
            v.status === "Pending" && !v.is_received ? " " : v.new_price,
          "Receiving Date": v.receiving_date
            ? moment(v.receiving_date).format("DD/MM/YYYY")
            : "",
          Total: (v.is_received && v.items.total_price) || 0,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const applyFilters = (data) => {
    let filtered = [...data];

    if (supplierFilter.length > 0) {
      filtered = filtered.filter(
        (row) =>
          row.supplier_name && supplierFilter.includes(row.supplier_name),
      );
    }

    if (branchFilter.length > 0) {
      filtered = filtered.filter(
        (row) => row.branch_name && branchFilter.includes(row.branch_name),
      );
    }

    if (itemFilter.length > 0) {
      filtered = filtered.filter(
        (row) => row.item_name && itemFilter.includes(row.item_name),
      );
    }

    if (statusFilter.length > 0) {
      filtered = filtered.filter(
        (row) => row.status && statusFilter.includes(row.status),
      );
    }

    if (invoiceFilter.trim()) {
      filtered = filtered.filter(
        (row) =>
          row.formatted_invoice_number &&
          row.formatted_invoice_number
            .toLowerCase()
            .includes(invoiceFilter.toLowerCase()),
      );
    }

    if (searchText.trim()) {
      filtered = filtered.filter((row) => {
        if (!row) return false;
        const searchLower = searchText.toLowerCase();

        const searchableFields = [
          row.supplier_name,
          row.branch_name,
          row.item_name,
          row.po_id,
          row.status,
          row.formatted_invoice_number,
        ];

        return searchableFields.some(
          (field) =>
            field && field.toString().toLowerCase().includes(searchLower),
        );
      });
    }

    setPreviousFilteredOrders(filtered);
    return filtered;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Supplier Monthly Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Supplier Monthly Report")}
          />
          <Row>
            <Col lg={12}>
              <Card style={{ padding: "5px", margin: "0px 0px 4px 0px" }}>
                <AvForm>
                  <Row className="align-items-center">
                    <Col lg={3}>
                      <AvField
                        name="dateFrom"
                        label={props.t("From Date")}
                        placeholder={props.t("Select")}
                        type="date"
                        value={dateFrom}
                        onChange={(e) => {
                          const selectedDate = e.target.value;
                          setDateFrom(
                            moment(selectedDate).format("YYYY-MM-DD"),
                          );

                          const maxDate = moment(selectedDate)
                            .add(30, "days")
                            .format("YYYY-MM-DD");
                          const currentDate = moment().format("YYYY-MM-DD");

                          if (
                            moment(dateTo).isAfter(maxDate) ||
                            moment(dateTo).isAfter(currentDate)
                          ) {
                            setDateTo(
                              maxDate > currentDate ? currentDate : maxDate,
                            );
                          }
                        }}
                        max={moment().format("YYYY-MM-DD")}
                        errorMessage={props.t("Date cannot be empty.")}
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                    <Col lg={3}>
                      <AvField
                        name="dateTo"
                        label={props.t("To Date")}
                        placeholder={props.t("Select")}
                        type="date"
                        value={dateTo}
                        onChange={(e) => {
                          const selectedDate = e.target.value;
                          setDateTo(moment(selectedDate).format("YYYY-MM-DD"));
                        }}
                        min={dateFrom}
                        max={
                          moment(dateFrom)
                            .add(30, "days")
                            .format("YYYY-MM-DD") >
                          moment().format("YYYY-MM-DD")
                            ? moment().format("YYYY-MM-DD")
                            : moment(dateFrom)
                                .add(30, "days")
                                .format("YYYY-MM-DD")
                        }
                        errorMessage={props.t("Date cannot be empty.")}
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Button
                        type="button"
                        className="btn btn-md btn-success mt-1"
                        disabled={isLoadingOrders}
                        onClick={() => {
                          if (dateFrom && dateTo) {
                            loadOrders();
                          }
                        }}
                      >
                        <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                        {props.t("Check")}
                      </Button>
                    </Col>
                    <Col lg={3}>
                      <div className="d-flex justify-content-end align-items-center">
                        <Button
                          type="submit"
                          className="btn btn-sm btn-secondary mr-2"
                          onClick={handleDownload}
                        >
                          <i className="mdi mdi-file-export"></i>{" "}
                          {props.t("Export CSV")}
                        </Button>
                        <Link
                          to="#"
                          onClick={() => printDiv("Supplier Monthly Report")}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </AvForm>
                {/* </CardBody> */}
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="Supplier Monthly Report">
                    <ToolkitProvider
                      keyField="row_key"
                      data={filteredOrders || []}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4} md={4} sm={4}>
                              <div className="mb-2">
                                <div className="position-relative w-75">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={"Search..."}
                                    value={searchText}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                    style={{ fontSize: "12px" }}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col lg={4}>
                              {" "}
                              <CardTitle className="text-center">
                                {"Supplier Monthly Report"}
                              </CardTitle>
                            </Col>
                            <Col lg={4} className="text-right">
                              <h5>
                                {" "}
                                Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            filter={filterFactory()}
                            condensed
                            pagination={paginationFactory(paginationOptions)}
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(SupplierMonthlyReport)),
);
